var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-check-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M51.6666 32.2915V17.5665C51.6666 13.2261 51.6666 11.0559 50.8219 9.39808C50.0789 7.93982 48.8933 6.75422 47.4351 6.0112C45.7773 5.1665 43.6071 5.1665 39.2666 5.1665H22.7333C18.3929 5.1665 16.2227 5.1665 14.5649 6.0112C13.1066 6.75422 11.921 7.93982 11.178 9.39808C10.3333 11.0559 10.3333 13.2261 10.3333 17.5665V44.4332C10.3333 48.7736 10.3333 50.9438 11.178 52.6016C11.921 54.0599 13.1066 55.2454 14.5649 55.9885C16.2227 56.8332 18.3929 56.8332 22.7333 56.8332H31M36.1666 28.4165H20.6666M25.8333 38.7498H20.6666M41.3333 18.0832H20.6666M37.4583 49.0832L42.625 54.2498L54.25 42.6248",
    stroke: "#45C49E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon4);
export default __webpack_public_path__ + "static/media/videoIcon4.335e779cde00018944a4bdc17b24adfb.svg";
export { ForwardRef as ReactComponent };